import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useQuery } from "@apollo/react-hooks";
import { withQuery } from "containers/withQuery";
import Select from "react-select";
import {
  Row, Col, Container, Input
} from "reactstrap";

import Modal from "components/Modal/Modal";
import RegularField from "components/Field/Field";
import { StockRegulateFooter } from "./StockRegulateFooter";
import { ITEMS_AND_LOCATIONS_QUERY } from "./stockInputQueries";

const Field = styled(RegularField)`
  margin-bottom: 25px;
`;

const StockRegulateModal = ({
  title,
  onSubmit,
  isOpen,
  toggleModal,
  inventoryItems,
}) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [correctedQuantity, setCorrectedQuantity] = useState(null);
  const [locations, setLocations] = useState([]);
  const [inputQuantity, setInputQuantity] = useState(0);

  const formatLocations = () => {
    const locationIds = inventoryItems.reduce((acc, item) => {
      if (item.inventoryLocations) {
        item.inventoryLocations.forEach(location => {
          acc.push(location.id);
        });
      }
      return acc;
    }, []);

    const uniqueLocationIds = locationIds.filter((num) => locationIds.indexOf(num) === locationIds.lastIndexOf(num));

    const formattedLocations = inventoryItems.reduce((acc, item) => {
      if (item.inventoryLocations) {
        item.inventoryLocations.forEach(location => {
          if (uniqueLocationIds.includes(location.id)) {
            acc.push({
              itemId: item.id,
              inventoryQuantity: location.inventoryQuantity,
              locationId: location.id,
              locationName: location.name,
            });
          }
        });
      }
      return acc;
    }, []);
    return formattedLocations;
  };

  const onChangeLocation = (value) => {
    setInputQuantity(0);
    setCorrectedQuantity(null);
    setSelectedLocation(value);
  };

  const onChangeQuantity = (event) => {
    const quantity = event.target.value - selectedLocation.inventoryQuantity;
    setInputQuantity(event.target.value);
    setCorrectedQuantity(quantity);
  };

  const onSaveEntry = () => {
    onSubmit({
      inventoryLocationId: selectedLocation.value,
      inventoryItemId: selectedLocation.itemId,
      quantity: correctedQuantity,
    });
  };

  useEffect(() => {
    if (inventoryItems && inventoryItems.length > 0) {
      const formattedLocations = formatLocations();
      setLocations(formattedLocations);
    }
  }, [inventoryItems]);

  return (
    <Modal
      title={title}
      isOpen={isOpen}
      toggleModal={toggleModal}
      footer={<StockRegulateFooter onConfirm={onSaveEntry} disabled={!selectedLocation || !correctedQuantity} />}
    >
      <Container fluid>
        <Row>
          <Col>
            <Field title="Local de estoque">
              {locations && (
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="itemSelected"
                  value={selectedLocation}
                  onChange={value => onChangeLocation(value)}
                  options={[
                    {
                      value: "",
                      isDisabled: true
                    },
                    ...locations
                      .sort((a, b) => a.locationId - b.locationId)
                      .map(({
                        locationId,
                        locationName,
                        itemId,
                        inventoryQuantity
                      }) => ({
                        value: locationId,
                        label: locationName,
                        itemId,
                        inventoryQuantity
                      }))
                  ]}
                  placeholder="Escolha um..."
                />
              )}
            </Field>
          </Col>
          <Col>
            <Field title="Quantidade">
              <Input
                style={{ minHeight: "40px" }}
                type="number"
                onChange={onChangeQuantity}
                value={inputQuantity}
                disabled={!selectedLocation}
              />
            </Field>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
};

export default withQuery({
  query: ITEMS_AND_LOCATIONS_QUERY
})(StockRegulateModal);
